// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/example-function-ping').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-function-ping/build.source.js
// module id = 283
// module chunks = 6